<template>
    <div>
        <b-img fluid-grow :src="imageFiles[0].file.public_path" width="64" v-if="imageFiles.length">
        </b-img>

        <design-2021-apprentice-video-player-component :options="getVideoOptions()"
                                                       :key="Math.floor(Math.random() * 100)"
                                                       v-else>
        </design-2021-apprentice-video-player-component>
    </div>
</template>

<script>
    export default {
        name: "design-2021-profile-timeline-media-widget-component",
        props: {
            imageFiles: Array,
            videoFiles: Array,
            videoLinks: Array
        },
        methods: {
            supportedVideoFormats() {
                for(const video of this.videoFiles) {
                    if (video.file.extension.toLowerCase() !== 'avi') {
                        return true
                        break;
                    }
                }
                return false
            },

            getSource(files){
                for(const video of files){
                    if(video.file.extension.toLowerCase() !== 'avi'){
                        return [{
                            type: `video/${video.file.extension.toLowerCase()}`,
                            src: video.file.public_path
                        }]
                        break;
                    }
                }
            },

            getVideoOptions() {
                let source = [];
                if(this.videoFiles.length !== 0){
                    source.push({
                        src: this.videoFiles[0].file ? this.videoFiles[0].file.public_path : '',
                        type: `video/${this.videoFiles[0].file.extension}`,
                    });
                }

                if(this.videoLinks.length !== 0){
                    source.push({
                        src: this.videoLinks[0].url ? this.videoLinks[0].url : '',
                        type: "video/youtube",
                    });
                }

                return {
                    autoplay: false,
                    controls: true,
                    sources: source,
                }
            }
        }
    }
</script>

<style scoped>

</style>
